import { render } from "./CreateDataScopeForm.vue?vue&type=template&id=3ecdc629&scoped=true"
import script from "./CreateDataScopeForm.vue?vue&type=script&lang=js"
export * from "./CreateDataScopeForm.vue?vue&type=script&lang=js"

import "./CreateDataScopeForm.vue?vue&type=style&index=0&id=3ecdc629&scoped=true&lang=css"
import "./CreateDataScopeForm.vue?vue&type=style&index=1&id=3ecdc629&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecdc629"]])

export default __exports__